import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pivot-table",
  "use": "pivot-table-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"pivot-table\"><path fill-rule=\"evenodd\" d=\"M22.5 14H21v3a2 2 0 0 1-2 2h-3v1.5L13 18l3-2.5V17h3v-3h-1.5l2.5-3 2.5 3ZM5 17h6v-4H5v4Zm0-6h6V7H5v4Zm4.876 7 1.844-1.536L13 15.396V13h2.729l.235-.28L17.396 11H13V7h6v2.076l1-1.2 1 1.2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6.076l-1.2-1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol